<template>
  <div class="global-filial-select">
    <v-select
      v-model="selectedItem"
      :items="filteredRows"
      item-text="name"
      item-value="id"
      label="Филиал"
      hide-details="auto"
      background-color="#fff"
      height="40"
      style="border-radius: 10px;"
      flat
      solo
      :loading="loadingList || loadingGlobalList"
      :disabled="loadingList || loadingGlobalList"
      :menu-props="{contentClass: 'global-filial-select-menu', maxHeight: '90vh'}"
      no-data-text="Филиалы не найдены"
      return-object
      :multiple="multiple"
      @change="onChange"
    >
      <template v-slot:prepend-item>
        <v-list-item class="search-global-filial">
          <v-list-item-content>
            <v-text-field
              v-model="search"
              placeholder="Поиск..."
              filled
              dense
            >
              <template v-slot:append>
                <font-awesome-icon color="#FF9100" icon="search" />
              </template>
            </v-text-field>
          </v-list-item-content>
        </v-list-item>
      </template>

      <template v-slot:selection="{item, index}">
        <filial-select-with-presets-item
          v-if="!multiple || selectedItem.length === 1"
          :item="item"
          :is-select-value="true"
        />
        <span v-else-if="index === 1">
          {{ multipleFilialSelectLabel }}
        </span>
      </template>

      <template v-slot:item="{item, attrs}">
        <filial-select-with-presets-item
          :item="item"
          :selected="attrs['aria-selected'] === 'true'"
          :width="'100%'"
          :is-list-item="true"
        />
      </template>
    </v-select>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import snackbarMessage from '@/mixins/snackbar-message'
  import FilialSelectWithPresetsItem from '@/components/ui/filial-with-presets/FilialSelectWithPresetsItem.vue'
  import StatisticReferenceDataService from '@/services/api/StatisticReferenceDataService'
  import { numWord } from '@/util/string'

  export default {
    name: 'FilialSelectWitsPresets',
    components: { FilialSelectWithPresetsItem },
    mixins: [snackbarMessage],
    props: {
      value: {
        type: [String, Number, Array],
        default: null,
      },
      disablePresets: {
        type: Boolean,
        default: false,
      },
      multiple: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        search: '',
        filials: [],
        presets: [],
        loadingList: false,
        selectedItem: null,
      }
    },
    computed: {
      ...mapGetters({
        allFilials: 'branches/getBranches',
        loadingGlobalList: 'branches/getLoadingListState',
      }),
      rows () {
        const data = this.filials.map(filial => {
          return {
            id: filial.id,
            filialName: filial.name,
            name: filial.address || filial.name,
            description: filial.city,
            icon: this.getFilialIcon(filial),
            type: 'filial',
          }
        })

        const presets = this.presets.map(preset => {
          return {
            id: preset.key,
            name: preset.name,
            description: preset.description,
            icon: `preset-${preset.key}`,
            type: 'preset',
          }
        })

        return [...presets, ...data]
      },
      filteredRows () {
        return this.rows.filter((item) => {
          const key = item.type === 'filial' ? 'filialName' : 'name'

          return item[key].toLowerCase().indexOf(this.search.toLowerCase()) > -1
        })
      },
      multipleFilialSelectLabel () {
        return `Выбрано ${this.selectedItem.length} ${numWord(this.selectedItem.length, 'филиал', 'филиала', 'филиалов')}`
      },
    },
    watch: {
      loadingGlobalList () {
        if (this.disablePresets && !this.loadingGlobalList) {
          this.filials = this.allFilials.slice()
        }
      },
    },
    created () {
      this.selectedItem = this.value
      if (this.disablePresets) {
        this.filials = this.allFilials.slice()
        this.normalizeSelectedItem()
      } else {
        this.loadFilialsDataWithPresets()
      }
    },
    methods: {
      getFilialIcon (filial) {
        if (!filial.status) return 'deactivated-filial'
        if (filial.franchise) return 'franchise-filial'
        return 'own-filial'
      },
      normalizeSelectedItem () {
        if (this.multiple && Array.isArray(this.value)) {
          this.selectedItem = this.value.map(item => {
            return isNaN(item) ? item : this.rows.find(row => row.id === item)
          })

          this.$emit('change', this.selectedItem)
        }
      },
      async loadFilialsDataWithPresets () {
        this.loadingList = true
        try {
          const data = await StatisticReferenceDataService.getFilialsWithPresets()
          this.filials = data.filials || []
          this.presets = data.presets || []
          this.normalizeSelectedItem()
        } catch (e) {
          this.showErrorFromResponse(e)
        }
        this.loadingList = false
      },
      onChange (items) {
        if (Array.isArray(items) && items.length > 1) {
          items = items[items.length - 1].type === 'preset'
            ? items.filter(item => item.type === 'preset').slice(-1)
            : items.filter(item => item.type === 'filial')

          this.selectedItem = items.slice()
        }

        this.$emit('change', items)
      },
    },

  }
</script>

<style lang="less">

.global-filial-select {

  &__icon {
    margin-right: 7px;
  }

  .v-select__selections {
    font-size: 14px;
  }

}

.global-filial-select-menu {
  box-shadow: 0px 4px 34px 0px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
}

.search-global-filial {
  margin-top: -8px;
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 10;
  //border-bottom: 1px solid rgba(0, 0, 0, 0.12);

  .v-text-field {
    & > .v-input__control {
      & > .v-input__slot {
        &:after,
        &:before {
          display: none;
        }
      }
    }
  }
  .v-input {
    border-radius: 5px;
    input {
      font-size: 14px;
    }

    &.v-text-field--outlined.v-input--is-focused fieldset {
      border: 1px solid rgba(0,0,0, 0.7) !important;
    }

    &__append-inner {
      margin: auto 0 !important;
    }
  }
  .v-text-field__details {
    display: none;
  }
}
</style>
